import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class FinancialReportFilterVm {
	monthYearString?: string;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'monthYearString': new UntypedFormControl(null, [...(validators['monthYearString'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): FinancialReportFilterVmFromFg {
		return new FinancialReportFilterVmFromFg(fg);
	}
}

export class FinancialReportFilterVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get monthYearString(): string {
		return this.fg.get('monthYearString').value;
	}
	set monthYearString(val) {
		this.fg.get('monthYearString').setValue(val);
	}
}
